import { cn } from '@/lib/utils'

export function Logo({ collapsed = false, className }: { collapsed?: boolean; className?: string }) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div className="relative h-8 w-8 shrink-0">
        <div className="absolute inset-0 rotate-45 rounded-sm bg-brand-terracotta" />
        <div className="absolute inset-[6px] rotate-45 rounded-sm bg-brand-ink" />
      </div>
      {!collapsed && (
        <span className="font-display text-xl font-bold tracking-tight text-brand-ink dark:text-brand-cream">
          DistroOps
        </span>
      )}
    </div>
  )
}
